import React, { useEffect, useRef, useState } from "react";
import AudioPlayer from "react-h5-audio-player";

// core components
import MainNavbar from "components/Navbars/MainNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import MainHeader from "components/Headers/MainHeader";
import Playlist from "components/PlayList";
import { Col, Container, Row } from "reactstrap";

function Demos() {
  document.documentElement.classList.remove("nav-open");
  const [commercialStatusPlay,setCommercialStatusPlay] = useState(false);
  const [characterStatusPlay,setCharacterStatusPlay] = useState(false);
  React.useEffect(() => {
    document.body.classList.add("about-me");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-me");
    };
  },[]);

  const commercialVoiceDemos = [
    {
      id: 1,
      title: "🎧 Full Demo",
      url: "https://shannenaudio.netlify.app/Shannen%20Velasco%20Commercial%20Demo.mp3",
    },
    {
      id: 2,
      title: "💄 Maybelline",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Maybelline.mp3",
    },
    {
      id: 3,
      title: "🧸 Lego",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Lego.mp3",
    },
    {
      id: 4,
      title: "🍔 Chili's",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Chili_s.mp3",
    },
    {
      id: 5,
      title: "✈️ Grand Canyon",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Grand%20Canyon.mp3",
    },
    {
      id: 6,
      title: "💳 Capital One",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Capital%20One.mp3",
    },
    {
      id: 7,
      title: "💻 Adobe Creative Cloud",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Adobe.mp3",
    },
    {
      id: 8,
      title: "🎨 Michaels",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Michael_s.mp3",
    },
    {
      id: 9,
      title: "🚑 CareNow Urgent Care",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Care%20Now.mp3",
    },
    {
      id: 10,
      title: "🛍️ TJ Maxx",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20TJ%20Max.mp3",
    },
    {
      id: 11,
      title: "🎃 Spirit Halloween",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Spirit%20Halloween.mp3",
    },
    {
      id: 12,
      title: "🎵  Spotify",
      url: "https://shannenaudio.netlify.app/Shannen%20V%20Spotify.mp3",
    },
  ];

  const characterWorkSamples = [
    {
      id: 1,
      title: "🎧 Full Character Work Samples",
      url: "https://shannenaudio.netlify.app/ShannenVelasco_Reel%202024.wav",
    },
  ];
  const onPlayHandler = (id) => {
  console.log('[WHAT IS MY ID]',id);
    if(id === 'commercial') {
      setCharacterStatusPlay(false);
      setCommercialStatusPlay(true);

    } else if (id === 'character') {
      setCommercialStatusPlay(false);
      setCharacterStatusPlay(true);
    }

  }
  return (
    <>
      <MainNavbar />
      <MainHeader title="Demos"/>
      <div className="main">
       
          <div className="section" style={{
          padding:40
        }}>
          <Container>
            <Row>
              <Col>
            <Playlist
              title="Commercial"
              description=""
              onPlayHandler={onPlayHandler}
              id="commercial"
              statusPlay={commercialStatusPlay}
              voiceDemos={commercialVoiceDemos}
            />
            </Col>
            <Col>
            <div style={{ paddingTop: 60 }}>
              <Playlist
                id="character"
                title="Character Samples"
                // description="Showcase of some of Shannen's previous voice roles"
                statusPlay={characterStatusPlay}
                onPlayHandler={onPlayHandler}
                voiceDemos={characterWorkSamples}
              />
    
          </div>
          </Col>
          </Row>
          </Container>
        </div>
      </div>

      <MainFooter />
    </>
  );
}

export default Demos;
